// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.image-viewer-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  user-select: none;
  gap: 8px;
  background-color: var(--ToolbarBackgroundColour);
}

.image-viewer-wrapper .image-viewer {
  position: relative;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #595959;
  border-radius: 8px;
  background-color: lightgrey;
}

.image-viewer-wrapper .main-image {
  max-width: 100%;
  max-height: 100%;
  pointer-events: none;
  user-select: none;
  object-fit: contain;
}

.image-viewer-wrapper .nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 10;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  border-radius: 50%;
}

.image-viewer-wrapper .nav-arrow:hover:not(.disabled) {
  opacity: 1;
}

.image-viewer-wrapper .nav-arrow.disabled {
  cursor: default;
  opacity: 0.3;
  pointer-events: none;
}

.image-viewer-wrapper .left-arrow {
  left: 12px;
}

.image-viewer-wrapper .right-arrow {
  right: 12px;
}

.image-viewer-wrapper .viewer-toolbar {
  height: 41px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.image-viewer-wrapper .image-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.image-viewer-wrapper .image-name {
  font-weight: 400;
  /* color: var(--ceoTrackTitleColor); */
  font-size: 14px;
}

.image-viewer-wrapper .image-timestamp {
  font-size: 16px;
  font-weight: var(--header-FontWeight);
  color: var(--ceoTrackTextColor);
}

.image-viewer-wrapper .viewer-controls {
  height: 40px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--button-disabled-color);
  border-radius: 20px;
  padding: 0px 4px;
}

.image-viewer-wrapper .viewer-controls .MuiSvgIcon-root {
  color: var(--button-color);
}

.image-viewer-wrapper .control-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  transition: background-color 0.2s ease;
}

.control-button:hover:not(:disabled) {
  background-color: #e0e0e0;
}

.control-button:disabled {
  cursor: default;
  opacity: 0.4;
}

.close-button {
  color: #b00;
}

.vertical-separator {
  height: 24px;
  border-left: 1px solid #b6b6b6;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/components/ImageViewer/ImageViewer.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;EACR,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,UAAU;AACZ","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.image-viewer-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  user-select: none;\n  gap: 8px;\n  background-color: var(--ToolbarBackgroundColour);\n}\n\n.image-viewer-wrapper .image-viewer {\n  position: relative;\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  border-radius: 8px;\n  border: 1px solid #595959;\n  border-radius: 8px;\n  background-color: lightgrey;\n}\n\n.image-viewer-wrapper .main-image {\n  max-width: 100%;\n  max-height: 100%;\n  pointer-events: none;\n  user-select: none;\n  object-fit: contain;\n}\n\n.image-viewer-wrapper .nav-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  z-index: 10;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n  border-radius: 50%;\n}\n\n.image-viewer-wrapper .nav-arrow:hover:not(.disabled) {\n  opacity: 1;\n}\n\n.image-viewer-wrapper .nav-arrow.disabled {\n  cursor: default;\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n.image-viewer-wrapper .left-arrow {\n  left: 12px;\n}\n\n.image-viewer-wrapper .right-arrow {\n  right: 12px;\n}\n\n.image-viewer-wrapper .viewer-toolbar {\n  height: 41px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.image-viewer-wrapper .image-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.image-viewer-wrapper .image-name {\n  font-weight: 400;\n  /* color: var(--ceoTrackTitleColor); */\n  font-size: 14px;\n}\n\n.image-viewer-wrapper .image-timestamp {\n  font-size: 16px;\n  font-weight: var(--header-FontWeight);\n  color: var(--ceoTrackTextColor);\n}\n\n.image-viewer-wrapper .viewer-controls {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid var(--button-disabled-color);\n  border-radius: 20px;\n  padding: 0px 4px;\n}\n\n.image-viewer-wrapper .viewer-controls .MuiSvgIcon-root {\n  color: var(--button-color);\n}\n\n.image-viewer-wrapper .control-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  transition: background-color 0.2s ease;\n}\n\n.control-button:hover:not(:disabled) {\n  background-color: #e0e0e0;\n}\n\n.control-button:disabled {\n  cursor: default;\n  opacity: 0.4;\n}\n\n.close-button {\n  color: #b00;\n}\n\n.vertical-separator {\n  height: 24px;\n  border-left: 1px solid #b6b6b6;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
